export const NODE_URL = "https://fullnode.devnet.aptoslabs.com/v1";
export const NFT_PRIZE_GAME_MODULE_ADDR =
  "0xdae84b032a3919cfd425f75a49cab6cb505b15706f67c7d58a4dd41b0254569e";
export const DATA_FETCHING_FREQ_MS = 30000;
